import { API } from "aws-amplify";
import { updateOffer } from "~/graphql/mutations";
import * as APITypes from "~/API";
import { EMPTY_OFFER_INFO } from "../getLeaseInfo/getOfferInfo";

export const editOffer = async (payload: APITypes.UpdateOfferInput) => {
  try {
    if (!payload.id || payload.id.trim() === "") {
      throw new Error("Invalid offer ID: ID cannot be empty");
    }

    const response = (await API.graphql({
      query: updateOffer,
      variables: {
        input: payload,
      },
    })) as { data: { updateOffer: APITypes.Offer } };
    console.log("response", response);

    return {
      success: true,
      data: response.data.updateOffer || EMPTY_OFFER_INFO,
    };
  } catch (error) {
    console.error("Error editing lease offer", error);
    return {
      success: false,
      data: EMPTY_OFFER_INFO,
      error,
    };
  }
};
